declare const DEVELOPMENT: boolean;
declare const API_BASE_URL: string;
declare const LOADER_DELAY_IN_MS: number;
declare const FAV_LOCKER_KEY: string;
declare const PRV_USED_LOCKERS_KEY: string;
declare const STORAGE_BASE_URL: string;
declare const ROUTE: string;
declare const BYPASS_HOST_VALIDATION: boolean;
declare const RECAPTCHA_TRIGGER_LIMIT: number;
declare const RECAPTCHA_COUNTER: string;
declare const RECAPTCHA_SITE_KEY: string;
declare const MAPBOX_ACCESS_TOKEN: string;

const _DEVELOPMENT = DEVELOPMENT;
const _API_BASE_URL = API_BASE_URL;
const _LOADER_DELAY_IN_MS = LOADER_DELAY_IN_MS;
const _FAV_LOCKER_KEY = FAV_LOCKER_KEY;
const _PRV_USED_LOCKERS_KEY = PRV_USED_LOCKERS_KEY;
const _STORAGE_BASE_URL = STORAGE_BASE_URL;
const _ROUTE = ROUTE;
const _BYPASS_HOST_VALIDATION = BYPASS_HOST_VALIDATION;
const _RECAPTCHA_TRIGGER_LIMIT = RECAPTCHA_TRIGGER_LIMIT;
const _RECAPTCHA_COUNTER = RECAPTCHA_COUNTER;
const _RECAPTCHA_SITE_KEY = RECAPTCHA_SITE_KEY;
const _MAPBOX_ACCESS_TOKEN = MAPBOX_ACCESS_TOKEN;

export {
    _DEVELOPMENT as DEVELOPMENT, 
    _API_BASE_URL as API_BASE_URL,
    _LOADER_DELAY_IN_MS as LOADER_DELAY_IN_MS,
    _FAV_LOCKER_KEY as FAV_LOCKER_KEY,
    _PRV_USED_LOCKERS_KEY as PRV_USED_LOCKERS_KEY,
    _STORAGE_BASE_URL as STORAGE_BASE_URL,
    _ROUTE as ROUTE,
    _BYPASS_HOST_VALIDATION as BYPASS_HOST_VALIDATION, 
    _RECAPTCHA_TRIGGER_LIMIT as RECAPTCHA_TRIGGER_LIMIT,
    _RECAPTCHA_COUNTER as RECAPTCHA_COUNTER,
    _RECAPTCHA_SITE_KEY as RECAPTCHA_SITE_KEY,
    _MAPBOX_ACCESS_TOKEN as MAPBOX_ACCESS_TOKEN,
}